import { useForm as createUseForm } from "@ant-design-vue/use";
import lodash from "lodash";
import { defineAsyncComponent, reactive, toRaw } from "vue";
import i18n from "../../../../i18n";
import { addModal } from "../../../../app.logic";
import { modalStyleForm } from "../../../../utils/constant";
import { initUseForm } from "../../../../utils/form";
import { createLoading } from "../../../../utils/loading";
import { validateError } from "../../../../utils/validate";

export const { isLoading, setIsLoading } = createLoading();

export const ConfirmRequestForm = defineAsyncComponent(() => import("./ConfirmRequestForm"));

export const openModalForm = ({ props, onOk, bind, data, okText }) => {
    const refs = reactive({ form: null });
    const options = addModal({
        bind: lodash.merge(
            lodash.cloneDeep(modalStyleForm),
            {
                okText: okText? okText: i18n.global.t("views.request.licenseRequest.modal.confirm"),
                okButtonProps: { disabled: false },
                title: i18n.global.t("components.modal.confirm"),
                width: "500px",
                onOk: () => {
                    refs.form.callOnClickModalOk().then(record => {
                        onOk?.(record);
                        options.bind.onCancel();
                    });
                }
            },
            bind
        ),
        render: () => (
            <ConfirmRequestForm
                ref={e => {
                    if (e) refs.form = e;
                }}
                {...props}
                form={data}
            ></ConfirmRequestForm>
        )
    });
    return options;
};

export const onClickModalOk = ({ data }) => {
    return data.useForm
        .validate()
        .then(() => ({ ...toRaw(data.useForm.modelRef) }))
        .catch(error => {
            validateError({ error });
            throw error;
        });
};

export const createForm = () => {
    return {

    };
};

export const createRules = ( ) => {
    return {

    };
};

export const createField = () => {
    return [
    ];
};

export const loadForm = ({ props, data }) => {
    setIsLoading(true);
    const { form } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    let promise = null;
    if (form) {
        promise = Promise.resolve({ data: [form] });
    } else {
        promise = Promise.resolve({ data: [modelRef] });
    }
    return promise.then(page => initUseForm({ data, page })).finally(() => setIsLoading(false));
};

export const initForm = ({ props, data, refs }) => {
    data.form = createForm({ props, data, refs });
    data.rules = createRules({ props, data, refs });
    data.useForm = createUseForm(data.form, data.rules);
    data.fields = createField({ props, data, refs });
    loadForm({ props, data, refs });
};
